var MDB = window.MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Sites = MDB.GDPR.Sites || {};

$.extend(MDB.GDPR.Sites, {
    bootView: function () {
        var hasActivePopup = false;

        $('.btn-link-supplier').on('click', function() {
            if(hasActivePopup) {
                return;
            }
           
            hasActivePopup = true;
           
            MDB.GDPR.Sites.displayLinkerPopup($(this), function () {
                hasActivePopup = false;
            });
        });


        var uploadFileButton = $('#uploadFile');
        var fileUploadDialog = $('#fileUpload');

        uploadFileButton.click(function (e) {
            e.preventDefault();
            fileUploadDialog.click();
        });

        MDB.GDPR.Sites.bindPromptButtons('.requires-confirm');
    },
    displayLinkerPopup: function (el, onClose) {
        el = $(el);
       
        $.ajax({
            url: el.data('popupUrl'),
            success: function (data) {
                var $data = $(data);
                $data.find('select').kendoDropDownList();

                //IE does not support the fade animation
                if (window.ActiveXObject || "ActiveXObject" in window) {
                    $('.modal').removeClass('fade');
                }

                $data.modal();

                $data.on('hidden.bs.modal', onClose);

                $data.find('.btn-submit').on('click', function(e){
                    var form = $data.find('form');
                    form.submit();
                });

                $('body').append($data);
            }
        });
    },
    fileUploadClick: function(id) {
        $('#fileUpload-' + id).click();
    },
    fileUploadChange: function (id) {
        $('#submitFile-' + id).click();
    }
});